import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCriteriaRatingAvailableColumns } from './api';

export const path = '/criteria-rating/list';

const PageCriteriaRatingList: React.FC = (props) => {
  const CriteriaRating = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCriteriaRatingAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CriteriaRating {...props} />;
};

export default PageCriteriaRatingList;
